import { useQuery } from '@tanstack/react-query';
import getSchoolyears from './getSchoolyears';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

export const SCHOOLYEARS_KEY = 'schoolyears';

export default function useSchoolyears(
  withPlaceholder?: boolean,
  withClassrooms?: boolean,
  filterYear?: number,
) {
  const user = useUser();
  return useQuery({
    queryKey: [SCHOOLYEARS_KEY, withClassrooms, filterYear],
    queryFn: () => getSchoolyears(user.location, withClassrooms, filterYear),
    refetchOnWindowFocus: false,

    placeholderData: withPlaceholder
      ? [
          {
            id: '1',
            year: 2000,
            label: '1999 - 2000',
            schools: [],
          },
          {
            id: '2',
            year: 2001,
            label: '2000 - 2001',
            schools: [],
          },
        ]
      : undefined,
  });
}
